module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"friendlyseacreatures","short_name":"friendlyseacreatures","start_url":"/","background_color":"#663399","display":"minimal-ui","icon":"config/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"707559636406c121dd1e53ba5dd402ae"},
    }]
